import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useCallback } from 'react'
import { useIsAccountPaused } from './useIsAccountPaused'
import { useIsImpersonating } from '../redux/selectors/currentUserSelectors'
import { useIsSelfServiceBillingAdmin } from './useIsSelfServiceBillingAdmin'
import { useRouter } from 'next/router'

/**
 * Redirects a paused account to Routes.PAUSED_ACCOUNT if the user
 * belongs to the an org that is paused
 *
 * Does not redirect if user is a billing admin trying to go to Routes.ACCOUNT
 * to update view invoices or update their payment info or if an internal admin
 * is impersonating
 */
export const useRedirectToPausedAccountPage = (): (() => void) => {
  const router = useRouter()
  const isSelfServiceBillingAdmin = useIsSelfServiceBillingAdmin()
  const isAccountPaused = useIsAccountPaused()
  const isImpersonating = useIsImpersonating()

  // Do not redirect the billing admin when they are attempting to go to
  // Routes.ACCOUNT to see their past invoices or update their payment info
  const billingAdminGoingToAccount =
    isSelfServiceBillingAdmin && [Routes.ACCOUNT].includes(router.pathname as Routes)

  // Do not redirect on these conditions
  const doNotRedirect = billingAdminGoingToAccount || isImpersonating

  const redirectToPausedAccountPage = useCallback(() => {
    if (doNotRedirect) return
    if (isAccountPaused)
      router.push({
        pathname: Routes.PAUSED_ACCOUNT
      })
  }, [router, doNotRedirect, isAccountPaused])
  return redirectToPausedAccountPage
}
